import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm$mappingData, _vm$apiData, _vm$apiData2, _vm$mappingData2, _vm$mappingData2$_vm$, _vm$mappingData2$_vm$2, _vm$mappingData2$_vm$3, _vm$mappingData3, _vm$mappingData3$_vm$, _vm$mappingData3$_vm$2, _vm$mappingData3$_vm$3;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "borderColor mb-4 p-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('h5', {
    staticClass: "font-weight-bold m-0 text-muted"
  }, [_vm._v("DI / DO 資 訊")]), _vm.hasRoleAdmin ? _c('div', {
    staticClass: "d-flex align-items-center ml-auto"
  }, [!_vm.hasCreatedData ? _c('b-form-input', {
    staticClass: "remarkInput mr-3",
    attrs: {
      "placeholder": "請輸入 Device ID",
      "type": "text",
      "size": "sm"
    },
    model: {
      value: _vm.newDeviceId,
      callback: function callback($$v) {
        _vm.newDeviceId = $$v;
      },
      expression: "newDeviceId"
    }
  }) : _vm.hasCreatedData && _vm.isEditing && _vm.dataAdmin.includes(_vm.userDetail.role) ? _c('b-form-input', {
    staticClass: "remarkInput mr-3",
    attrs: {
      "placeholder": "修改 Device ID",
      "type": "text",
      "size": "sm"
    },
    model: {
      value: _vm.editDeviceId,
      callback: function callback($$v) {
        _vm.editDeviceId = $$v;
      },
      expression: "editDeviceId"
    }
  }) : _vm._e(), !_vm.hasCreatedData ? _c('button', {
    staticClass: "confirmButton",
    class: {
      disableButton: _vm.isLoadingUpdate
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.writeDido
    }
  }, [_vm._v(" 新增 ")]) : _vm._e(), _vm.mappingData.length ? [_vm.isEditing ? _c('button', {
    staticClass: "confirmButton ml-3",
    class: {
      disableButton: _vm.isLoadingUpdate || !((_vm$mappingData = _vm.mappingData) !== null && _vm$mappingData !== void 0 && _vm$mappingData.length)
    },
    attrs: {
      "type": "button",
      "title": !_vm.isEditing ? '開啟修改後儲存' : ''
    },
    on: {
      "click": _vm.updateDido
    }
  }, [_vm._v(" 儲存 ")]) : _vm._e(), _c('button', {
    staticClass: "confirmButton ml-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.isEditing = !_vm.isEditing;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditing ? "關閉修改" : "修改") + " ")])] : _vm._e()], 2) : _vm._e()]), !_vm.hasRoleAdmin ? _c('v-expansion-panels', {
    attrs: {
      "multiple": "",
      "flat": "",
      "tile": ""
    },
    model: {
      value: _vm.panel,
      callback: function callback($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    staticClass: "border my-2"
  }, [_c('v-expansion-panel-header', {
    attrs: {
      "color": "acme_blue_light"
    }
  }, [_vm._v(" Device ID: "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s((_vm$apiData = _vm.apiData) === null || _vm$apiData === void 0 ? void 0 : _vm$apiData.deviceId) + " ")])]), _c('v-expansion-panel-content', {
    staticClass: "overflow-x-scroll"
  }, [_c('div', {
    staticClass: "panelContent_owner"
  }, [_c('div', {
    staticClass: "d-flex tableTitle text-nowrap mb-2"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("設備名稱")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("連線狀態")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("腳位")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("狀態")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("狀態顯示")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("腳位描述")])]), _c('b-alert', {
    staticClass: "text-center font-weight-bold mt-5 mb-0",
    attrs: {
      "show": !!_vm.noDataText,
      "variant": "secondary"
    }
  }, [_vm._v(" " + _vm._s(_vm.noDataText) + " ")]), _vm._l(_vm.mappingData, function (mItem, mIdx) {
    return _c('div', {
      key: mItem.deviceName,
      staticClass: "d-flex align-items-center border-bottom"
    }, [_c('div', {
      staticStyle: {
        "width": "15%",
        "line-height": "53.5px"
      },
      attrs: {
        "aria-expanded": _vm.collapseOpenRecord[mIdx],
        "aria-controls": 'collapse-name-' + mIdx
      },
      on: {
        "click": function click($event) {
          return _vm.$set(_vm.collapseOpenRecord, mIdx, !_vm.collapseOpenRecord[mIdx]);
        }
      }
    }, [_c('i', {
      staticClass: "box fas",
      class: [_vm.collapseOpenRecord[mIdx] ? 'fa-caret-down' : 'fa-caret-right'],
      staticStyle: {
        "width": "20px",
        "text-align": "center"
      }
    }), _vm._v(" " + _vm._s(mItem.deviceName) + " ")]), _c('div', {
      staticClass: "box",
      staticStyle: {
        "width": "15%"
      }
    }, [_vm.stateCurrentValueFromWS(mIdx) === 0 || mItem.state === 'ON' ? _c('i', {
      staticClass: "fas fa-check-circle text-success ml-5"
    }) : _c('i', {
      staticClass: "fas fa-times-circle text-purple ml-5"
    })]), _c('div', {
      staticStyle: {
        "width": "70%"
      }
    }, [_c('b-collapse', {
      attrs: {
        "id": 'collapse-name-' + mIdx
      },
      model: {
        value: _vm.collapseOpenRecord[mIdx],
        callback: function callback($$v) {
          _vm.$set(_vm.collapseOpenRecord, mIdx, $$v);
        },
        expression: "collapseOpenRecord[mIdx]"
      }
    }, _vm._l(mItem === null || mItem === void 0 ? void 0 : mItem.pinList, function (pin, pIdx) {
      var _vm$pinCurrentValueFr, _vm$pinCurrentValueFr2, _vm$pinCurrentValueFr3, _vm$pinCurrentValueFr4, _vm$pinCurrentValueFr5, _vm$pinCurrentValueFr6, _vm$pinCurrentValueFr7, _vm$pinCurrentValueFr8, _vm$pinCurrentValueFr9;
      return _c('div', {
        key: pin.pinName,
        staticClass: "d-flex align-items-center contentWrap py-2"
      }, [_c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(15% * 100 / 70)"
        }
      }, [_vm._v(" " + _vm._s(pin.pinName) + " ")]), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(15% * 100 / 70)"
        }
      }, [_c('b-badge', {
        staticClass: "d-none",
        class: {
          opacity_50: !pin.enabled
        },
        attrs: {
          "variant": ((_vm$pinCurrentValueFr = (_vm$pinCurrentValueFr2 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr2 === void 0 ? void 0 : _vm$pinCurrentValueFr2.value) !== null && _vm$pinCurrentValueFr !== void 0 ? _vm$pinCurrentValueFr : pin.currentValue) === 0 ? 'danger' : 'success'
        }
      }, [_vm._v(" " + _vm._s((_vm$pinCurrentValueFr3 = (_vm$pinCurrentValueFr4 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr4 === void 0 ? void 0 : _vm$pinCurrentValueFr4.value) !== null && _vm$pinCurrentValueFr3 !== void 0 ? _vm$pinCurrentValueFr3 : pin.currentValue) + " ")]), _c('span', {
        staticClass: "rounded-circle d-inline-block ml-2",
        class: {
          'bg-danger': ((_vm$pinCurrentValueFr5 = (_vm$pinCurrentValueFr6 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr6 === void 0 ? void 0 : _vm$pinCurrentValueFr6.value) !== null && _vm$pinCurrentValueFr5 !== void 0 ? _vm$pinCurrentValueFr5 : pin.currentValue) === 0,
          'bg-success': ((_vm$pinCurrentValueFr7 = (_vm$pinCurrentValueFr8 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr8 === void 0 ? void 0 : _vm$pinCurrentValueFr8.value) !== null && _vm$pinCurrentValueFr7 !== void 0 ? _vm$pinCurrentValueFr7 : pin.currentValue) === 1,
          opacity_50: !pin.enabled
        },
        staticStyle: {
          "width": "12px",
          "height": "12px"
        }
      })], 1), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(15% * 100 / 70)"
        }
      }, [_c('span', [_vm._v(" " + _vm._s((_vm$pinCurrentValueFr9 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr9 === void 0 ? void 0 : _vm$pinCurrentValueFr9.label) + " ")])]), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(25% * 100 / 70)"
        }
      }, [_c('span', {
        staticClass: "fz-15px ls-1px text-nowrap"
      }, [_vm._v(" " + _vm._s(pin.abnormalID) + " ")])])]);
    }), 0)], 1)]);
  })], 2)])], 1)], 1) : _c('v-expansion-panels', {
    attrs: {
      "multiple": "",
      "flat": "",
      "tile": ""
    },
    model: {
      value: _vm.panel,
      callback: function callback($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    staticClass: "border my-2"
  }, [_c('v-expansion-panel-header', {
    attrs: {
      "color": "acme_blue_light"
    }
  }, [_vm._v(" Device ID: "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s((_vm$apiData2 = _vm.apiData) === null || _vm$apiData2 === void 0 ? void 0 : _vm$apiData2.deviceId) + " ")])]), _c('v-expansion-panel-content', {
    staticClass: "overflow-x-scroll"
  }, [_c('div', {
    staticClass: "panelContent"
  }, [_c('div', {
    staticClass: "d-flex tableTitle text-nowrap mb-2"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("設備名稱")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("連線狀態")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("腳位")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("狀態")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("狀態顯示")]), _c('div', {
    staticClass: "box pl-4 border-left",
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(" 腳位描述 ")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("數值 0 顯示")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("數值 1 顯示")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("告警啟閉")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("異常定義")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("控制邏輯")]), _c('div', {
    staticClass: "box pl-3",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("遠端控制")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("啟用")]), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("設定更新")])]), _c('b-alert', {
    staticClass: "text-center font-weight-bold mt-5 mb-0",
    attrs: {
      "show": !!_vm.noDataText,
      "variant": "secondary"
    }
  }, [_vm._v(" " + _vm._s(_vm.noDataText) + " ")]), _vm._l(_vm.mappingData, function (mItem, mIdx) {
    return _c('div', {
      key: mItem.deviceName,
      staticClass: "d-flex align-items-center border-bottom"
    }, [_c('div', {
      staticStyle: {
        "width": "8%",
        "line-height": "53.5px"
      },
      attrs: {
        "aria-expanded": _vm.collapseOpenRecord[mIdx],
        "aria-controls": 'collapse-name-' + mIdx
      },
      on: {
        "click": function click($event) {
          return _vm.$set(_vm.collapseOpenRecord, mIdx, !_vm.collapseOpenRecord[mIdx]);
        }
      }
    }, [_c('i', {
      staticClass: "box fas",
      class: [_vm.collapseOpenRecord[mIdx] ? 'fa-caret-down' : 'fa-caret-right'],
      staticStyle: {
        "width": "20px",
        "text-align": "center"
      }
    }), _vm._v(" " + _vm._s(mItem.deviceName) + " ")]), _c('div', {
      staticClass: "box",
      staticStyle: {
        "width": "5%"
      }
    }, [_vm.stateCurrentValueFromWS(mIdx) === 0 || mItem.state === 'ON' ? _c('i', {
      staticClass: "fas fa-check-circle text-success ml-5"
    }) : _c('i', {
      staticClass: "fas fa-times-circle text-purple ml-5"
    })]), _c('div', {
      staticStyle: {
        "width": "87%"
      }
    }, [_c('b-collapse', {
      attrs: {
        "id": 'collapse-name-' + mIdx
      },
      model: {
        value: _vm.collapseOpenRecord[mIdx],
        callback: function callback($$v) {
          _vm.$set(_vm.collapseOpenRecord, mIdx, $$v);
        },
        expression: "collapseOpenRecord[mIdx]"
      }
    }, _vm._l(mItem === null || mItem === void 0 ? void 0 : mItem.pinList, function (pin, pIdx) {
      var _vm$pinCurrentValueFr10, _vm$pinCurrentValueFr11, _vm$pinCurrentValueFr12, _vm$pinCurrentValueFr13, _vm$pinCurrentValueFr14, _vm$pinCurrentValueFr15, _vm$pinCurrentValueFr16, _vm$pinCurrentValueFr17, _vm$pinCurrentValueFr18;
      return _c('div', {
        key: pin.pinName,
        staticClass: "d-flex align-items-center contentWrap"
      }, [_c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(7% * 100 / 87)"
        }
      }, [_vm._v(" " + _vm._s(pin.pinName) + " ")]), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(5% * 100 / 87)"
        }
      }, [_c('b-badge', {
        staticClass: "d-none",
        class: {
          opacity_50: !pin.enabled
        },
        attrs: {
          "variant": ((_vm$pinCurrentValueFr10 = (_vm$pinCurrentValueFr11 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr11 === void 0 ? void 0 : _vm$pinCurrentValueFr11.value) !== null && _vm$pinCurrentValueFr10 !== void 0 ? _vm$pinCurrentValueFr10 : pin.currentValue) === 0 ? 'danger' : 'success'
        }
      }, [_vm._v(" " + _vm._s((_vm$pinCurrentValueFr12 = (_vm$pinCurrentValueFr13 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr13 === void 0 ? void 0 : _vm$pinCurrentValueFr13.value) !== null && _vm$pinCurrentValueFr12 !== void 0 ? _vm$pinCurrentValueFr12 : pin.currentValue) + " ")]), !pin.enabled ? _c('span', {
        staticClass: "text-muted",
        staticStyle: {
          "font-size": "13px",
          "margin-left": "-5px"
        }
      }, [_vm._v(" 未啟用 ")]) : _c('span', {
        staticClass: "rounded-circle d-inline-block ml-2",
        class: {
          'bg-danger': ((_vm$pinCurrentValueFr14 = (_vm$pinCurrentValueFr15 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr15 === void 0 ? void 0 : _vm$pinCurrentValueFr15.value) !== null && _vm$pinCurrentValueFr14 !== void 0 ? _vm$pinCurrentValueFr14 : pin.currentValue) === 0,
          'bg-success': ((_vm$pinCurrentValueFr16 = (_vm$pinCurrentValueFr17 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr17 === void 0 ? void 0 : _vm$pinCurrentValueFr17.value) !== null && _vm$pinCurrentValueFr16 !== void 0 ? _vm$pinCurrentValueFr16 : pin.currentValue) === 1,
          opacity_50: !pin.enabled
        },
        staticStyle: {
          "width": "12px",
          "height": "12px"
        }
      })], 1), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(6% * 100 / 87)"
        }
      }, [!pin.enabled ? _c('span', {
        staticClass: "text-muted",
        staticStyle: {
          "font-size": "13px",
          "margin-left": "-5px"
        }
      }, [_vm._v(" 未啟用 ")]) : _c('span', [_vm._v(" " + _vm._s((_vm$pinCurrentValueFr18 = _vm.pinCurrentValueFromWS(mIdx, pIdx)) === null || _vm$pinCurrentValueFr18 === void 0 ? void 0 : _vm$pinCurrentValueFr18.label) + " ")])]), _c('div', {
        staticClass: "box pl-4 border-left",
        staticStyle: {
          "width": "calc(18% * 100 / 87)"
        }
      }, [_vm.isEditing ? _c('b-form-input', {
        staticClass: "remarkInput",
        class: {
          opacity_50: !pin.enabled
        },
        attrs: {
          "type": "text",
          "size": "sm",
          "disabled": !pin.enabled
        },
        on: {
          "change": function change($event) {
            return _vm.renewUpdateTime(mIdx, pIdx);
          }
        },
        model: {
          value: pin.abnormalID,
          callback: function callback($$v) {
            _vm.$set(pin, "abnormalID", $$v);
          },
          expression: "pin.abnormalID"
        }
      }) : _c('span', {
        staticClass: "p-2 pl-0 fz-15px ls-1px text-nowrap"
      }, [_vm._v(" " + _vm._s(pin.abnormalID) + " ")])], 1), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(7% * 100 / 87)"
        }
      }, [_vm.isEditing ? _c('b-form-input', {
        staticClass: "remarkInput",
        class: {
          opacity_50: !pin.enabled
        },
        attrs: {
          "type": "text",
          "size": "sm",
          "disabled": !pin.enabled
        },
        on: {
          "change": function change($event) {
            return _vm.renewUpdateTime(mIdx, pIdx);
          }
        },
        model: {
          value: pin.zeroOneDef.zero,
          callback: function callback($$v) {
            _vm.$set(pin.zeroOneDef, "zero", $$v);
          },
          expression: "pin.zeroOneDef.zero"
        }
      }) : _c('span', {
        staticClass: "p-2 pl-0 fz-15px ls-1px text-nowrap"
      }, [_vm._v(" " + _vm._s(pin.zeroOneDef.zero) + " ")])], 1), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(7% * 100 / 87)"
        }
      }, [_vm.isEditing ? _c('b-form-input', {
        staticClass: "remarkInput",
        class: {
          opacity_50: !pin.enabled
        },
        attrs: {
          "type": "text",
          "size": "sm",
          "disabled": !pin.enabled
        },
        on: {
          "change": function change($event) {
            return _vm.renewUpdateTime(mIdx, pIdx);
          }
        },
        model: {
          value: pin.zeroOneDef.one,
          callback: function callback($$v) {
            _vm.$set(pin.zeroOneDef, "one", $$v);
          },
          expression: "pin.zeroOneDef.one"
        }
      }) : _c('span', {
        staticClass: "p-2 pl-0 fz-15px ls-1px text-nowrap"
      }, [_vm._v(" " + _vm._s(pin.zeroOneDef.one) + " ")])], 1), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(5% * 100 / 87)"
        }
      }, [_c('v-switch', {
        staticClass: "m-0 ml-3",
        attrs: {
          "disabled": !pin.enabled || !_vm.isEditing,
          "true-value": "開啟警報",
          "false-value": "關閉警報",
          "ripple": false,
          "color": "energy_blue",
          "dense": "",
          "inset": "",
          "hide-details": ""
        },
        on: {
          "change": function change($event) {
            return _vm.changeUsage(pin.usage, mIdx, pIdx);
          }
        },
        model: {
          value: pin.usage,
          callback: function callback($$v) {
            _vm.$set(pin, "usage", $$v);
          },
          expression: "pin.usage"
        }
      })], 1), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(7% * 100 / 87)"
        }
      }, [pin.usage === '關閉警報' ? _c('div', {
        staticClass: "text-muted"
      }, [_vm._v(" - ")]) : _c('b-form-select', {
        class: {
          opacity_50: !pin.enabled
        },
        attrs: {
          "size": "sm",
          "options": _vm.abnormalDefOptions,
          "disabled": !pin.enabled || !_vm.isEditing
        },
        on: {
          "change": function change($event) {
            return _vm.renewUpdateTime(mIdx, pIdx);
          }
        },
        model: {
          value: pin.abnormalDef,
          callback: function callback($$v) {
            _vm.$set(pin, "abnormalDef", $$v);
          },
          expression: "pin.abnormalDef"
        }
      })], 1), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(6% * 100 / 87)"
        }
      }, [_c('v-btn', {
        staticClass: "ml-5 p-2",
        attrs: {
          "color": "#999",
          "depressed": "",
          "x-small": "",
          "icon": "",
          "disabled": !pin.enabled || !_vm.isEditing
        },
        on: {
          "click": function click($event) {
            return _vm.handleOpenModal(mIdx, pIdx);
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "#999"
        }
      }, [_vm._v("mdi-square-edit-outline")])], 1)], 1), _c('div', {
        staticClass: "box pl-3",
        staticStyle: {
          "width": "calc(10% * 100 / 87)"
        }
      }, [pin.pinName.includes('DO') ? _c('div', {
        staticClass: "d-flex align-items-center"
      }, [_c('b-form-select', {
        staticClass: "w-50",
        class: {
          opacity_50: !pin.enabled
        },
        attrs: {
          "size": "sm",
          "options": _vm.abnormalDefOptions,
          "disabled": !pin.enabled
        },
        model: {
          value: pin.execute,
          callback: function callback($$v) {
            _vm.$set(pin, "execute", $$v);
          },
          expression: "pin.execute"
        }
      }), _c('v-btn', {
        staticClass: "ml-3",
        attrs: {
          "color": "secondary",
          "depressed": "",
          "outlined": "",
          "small": "",
          "disabled": !pin.enabled,
          "loading": _vm.loadingDMRecord === "".concat(mItem.deviceName, "_").concat(pin.pinName)
        },
        on: {
          "click": function click($event) {
            return _vm.dmDido(mItem.deviceName, pin.pinName, pin.execute);
          }
        }
      }, [_vm._v(" 傳送 ")])], 1) : _c('div')]), _c('div', {
        staticClass: "box pl-1",
        staticStyle: {
          "width": "calc(4% * 100 / 87)"
        }
      }, [pin.pinName.includes('DO') ? _c('v-checkbox', {
        staticClass: "m-0",
        class: {
          opacity_50: !_vm.isEditing
        },
        attrs: {
          "color": "#999",
          "disabled": !_vm.isEditing,
          "hide-details": "",
          "dense": ""
        },
        on: {
          "change": function change($event) {
            return _vm.renewUpdateTime(mIdx, pIdx);
          }
        },
        model: {
          value: pin.enabled,
          callback: function callback($$v) {
            _vm.$set(pin, "enabled", $$v);
          },
          expression: "pin.enabled"
        }
      }) : _vm._e()], 1), _c('div', {
        staticClass: "box",
        staticStyle: {
          "width": "calc(5% * 100 / 87)",
          "font-size": "12px"
        }
      }, [_vm._v(" " + _vm._s(_vm.dayjs(pin.updateTime).format("YYYY-MM-DD HH:mm:ss")) + " ")])]);
    }), 0)], 1)]);
  })], 2)])], 1)], 1), _c('modal', {
    attrs: {
      "name": "draggableModal",
      "draggable": ".draggableContainer",
      "width": '90%',
      "height": "auto",
      "maxWidth": 1138,
      "adaptive": true
    },
    on: {
      "before-close": function beforeClose($event) {
        return _vm.beforeCloseModal($event, _vm.mappingIdx, _vm.pinIdx);
      }
    }
  }, [_c('div', {
    staticClass: "draggableContainer h-100"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between border-bottom p-3"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("控制邏輯 " + _vm._s(_vm.modalTitle))]), _c('v-btn', {
    attrs: {
      "color": "#fff",
      "fab": "",
      "depressed": "",
      "x-small": "",
      "ripple": false
    },
    on: {
      "click": function click($event) {
        return _vm.$modal.hide('draggableModal');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#a3a3a3"
    }
  }, [_vm._v("mdi-window-close")])], 1)], 1), _c('div', {
    staticClass: "p-3 border-bottom modalContent overflow-y-auto"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center tableTitle mb-2"
  }, [_c('div', {
    staticClass: "box_modal",
    staticStyle: {
      "width": "18.5%"
    }
  }, [_vm._v(" 腳位 " + _vm._s((_vm$mappingData2 = _vm.mappingData) === null || _vm$mappingData2 === void 0 ? void 0 : (_vm$mappingData2$_vm$ = _vm$mappingData2[_vm.mappingIdx]) === null || _vm$mappingData2$_vm$ === void 0 ? void 0 : (_vm$mappingData2$_vm$2 = _vm$mappingData2$_vm$.pinList) === null || _vm$mappingData2$_vm$2 === void 0 ? void 0 : (_vm$mappingData2$_vm$3 = _vm$mappingData2$_vm$2[_vm.pinIdx]) === null || _vm$mappingData2$_vm$3 === void 0 ? void 0 : _vm$mappingData2$_vm$3.pinName) + " 數值 ")]), _c('div', {
    staticClass: "box_modal",
    staticStyle: {
      "width": "18.5%"
    }
  }, [_vm._v("觸發腳位")]), _c('div', {
    staticClass: "box_modal",
    staticStyle: {
      "width": "18.5%"
    }
  }, [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": "上限 300"
    }
  }, [_vm._v("觸發延時 (s)")])]), _c('div', {
    staticClass: "box_modal",
    staticStyle: {
      "width": "18.5%"
    }
  }, [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": "上限 999999"
    }
  }, [_vm._v("執行次數")])]), _c('div', {
    staticClass: "box_modal",
    staticStyle: {
      "width": "18.5%"
    }
  }, [_vm._v("執行數值")]), _c('div', {
    staticClass: "box_modal",
    staticStyle: {
      "width": "7.5%"
    }
  }, [_c('v-btn', {
    staticClass: "btn_meter_add ml-auto",
    attrs: {
      "color": "#60acf7",
      "fab": "",
      "outlined": "",
      "depressed": "",
      "x-small": "",
      "ripple": false
    },
    on: {
      "click": function click($event) {
        return _vm.handleAddTriggerDO(_vm.mappingIdx, _vm.pinIdx);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#60acf7"
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)]), _vm._l((_vm$mappingData3 = _vm.mappingData) === null || _vm$mappingData3 === void 0 ? void 0 : (_vm$mappingData3$_vm$ = _vm$mappingData3[_vm.mappingIdx]) === null || _vm$mappingData3$_vm$ === void 0 ? void 0 : (_vm$mappingData3$_vm$2 = _vm$mappingData3$_vm$.pinList) === null || _vm$mappingData3$_vm$2 === void 0 ? void 0 : (_vm$mappingData3$_vm$3 = _vm$mappingData3$_vm$2[_vm.pinIdx]) === null || _vm$mappingData3$_vm$3 === void 0 ? void 0 : _vm$mappingData3$_vm$3.triggerDO, function (trigger, tIdx) {
    return _c('div', {
      key: tIdx,
      staticClass: "d-flex justify-content-between"
    }, [_c('div', {
      staticClass: "box_modal",
      staticStyle: {
        "width": "18.5%"
      }
    }, [_c('b-form-select', {
      staticClass: "remarkInput",
      attrs: {
        "type": "number",
        "size": "sm",
        "options": _vm.abnormalDefOptions
      },
      on: {
        "change": function change($event) {
          return _vm.handleTriggerChange(trigger, _vm.mappingIdx, _vm.pinIdx);
        }
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null,
              "disabled": ""
            }
          }, [_vm._v(" 請選擇 ")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: trigger.matchCurrentValue,
        callback: function callback($$v) {
          _vm.$set(trigger, "matchCurrentValue", $$v);
        },
        expression: "trigger.matchCurrentValue"
      }
    })], 1), _c('div', {
      staticClass: "box_modal",
      staticStyle: {
        "width": "18.5%"
      }
    }, [_c('b-form-select', {
      attrs: {
        "value": _vm.triggerDeviceKey(trigger, _vm.mappingIdx),
        "size": "sm",
        "options": _vm.triggerOptions
      },
      on: {
        "change": function change($event) {
          return _vm.handleTriggerDOSelect($event, trigger, _vm.mappingIdx, _vm.pinIdx);
        }
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null,
              "disabled": ""
            }
          }, [_vm._v(" 請選擇 ")])];
        },
        proxy: true
      }], null, true)
    })], 1), _c('div', {
      staticClass: "box_modal",
      staticStyle: {
        "width": "18.5%"
      }
    }, [_c('b-form-input', {
      staticClass: "remarkInput",
      attrs: {
        "type": "number",
        "placeholder": "請輸入",
        "size": "sm",
        "autocomplete": "off",
        "min": 0,
        "max": 300
      },
      on: {
        "change": function change($event) {
          return _vm.formatInput('postExecuteSecond', _vm.mappingIdx, _vm.pinIdx, tIdx);
        }
      },
      model: {
        value: trigger.postExecuteSecond,
        callback: function callback($$v) {
          _vm.$set(trigger, "postExecuteSecond", _vm._n($$v));
        },
        expression: "trigger.postExecuteSecond"
      }
    })], 1), _c('div', {
      staticClass: "box_modal",
      staticStyle: {
        "width": "18.5%"
      }
    }, [_c('b-form-input', {
      staticClass: "remarkInput",
      attrs: {
        "type": "number",
        "placeholder": "請輸入",
        "size": "sm",
        "autocomplete": "off",
        "min": 1,
        "max": 999999
      },
      on: {
        "change": function change($event) {
          return _vm.formatInput('executionCount', _vm.mappingIdx, _vm.pinIdx, tIdx);
        }
      },
      model: {
        value: trigger.executionCount,
        callback: function callback($$v) {
          _vm.$set(trigger, "executionCount", _vm._n($$v));
        },
        expression: "trigger.executionCount"
      }
    })], 1), _c('div', {
      staticClass: "box_modal",
      staticStyle: {
        "width": "18.5%"
      }
    }, [_vm.isTriggerSelf(trigger, _vm.mappingIdx, _vm.pinIdx) ? _c('span', {
      staticClass: "ml-2",
      staticStyle: {
        "line-height": "32.5px"
      }
    }, [_vm._v(" " + _vm._s(trigger.value) + " ")]) : _c('b-form-select', {
      staticClass: "remarkInput",
      attrs: {
        "type": "number",
        "size": "sm",
        "options": _vm.abnormalDefOptions
      },
      on: {
        "change": function change($event) {
          return _vm.renewUpdateTime(_vm.mappingIdx, _vm.pinIdx);
        }
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null,
              "disabled": ""
            }
          }, [_vm._v(" 請選擇 ")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: trigger.value,
        callback: function callback($$v) {
          _vm.$set(trigger, "value", $$v);
        },
        expression: "trigger.value"
      }
    })], 1), _c('div', {
      staticClass: "box_modal",
      staticStyle: {
        "width": "7.5%"
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "#bbb",
        "fab": "",
        "depressed": "",
        "outlined": "",
        "x-small": "",
        "ripple": false
      },
      on: {
        "click": function click($event) {
          return _vm.handleRemoveTriggerDO(_vm.mappingIdx, _vm.pinIdx, tIdx);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#a3a3a3"
      }
    }, [_vm._v("mdi-minus")])], 1)], 1)]);
  })], 2), _c('div', {
    staticClass: "p-3 d-flex align-items-center"
  }, [_c('b-button', {
    staticClass: "mr-auto",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.handleClearAllTriggerDO(_vm.mappingIdx, _vm.pinIdx);
      }
    }
  }, [_vm._v(" 清除全部 ")]), _c('span', {
    staticClass: "mr-3 fz-15px text-muted"
  }, [_vm._v("修改後記得儲存")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.$modal.hide('draggableModal');
      }
    }
  }, [_vm._v(" OK ")])], 1)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };